export { default } from './footer-legal-links';
